import { AlertTriangle } from "lucide-react";
import { cn } from "@/lib/cn";

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({ message, onRetry, className }: ErrorStateProps) {
  return (
    <div className={cn("flex flex-1 flex-col items-center justify-center px-8 py-16", className)}>
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-50 dark:bg-red-950/30">
        <AlertTriangle className="h-8 w-8 text-[var(--color-danger)]" />
      </div>

      <h2 className="mb-2 text-lg font-semibold text-[var(--color-text)]">
        Something went wrong
      </h2>

      <p className="mb-6 max-w-64 text-center text-sm text-[var(--color-text-secondary)]">
        {message}
      </p>

      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="rounded-[var(--radius-md)] bg-[var(--color-primary)] px-6 py-2.5
                     text-sm font-medium text-white transition-colors
                     hover:bg-[var(--color-primary-hover)] active:scale-[0.97]"
        >
          Try again
        </button>
      )}
    </div>
  );
}
